module.exports = __webpack_public_path__ + "static/media/List-App-Mobile-X-4.c806b5c0.png";